import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer } from '@ngrx/store';

export const editAllowedIpFeatureKey = 'editAllowedIp';

export interface EditAllowedIpState {
   callState: CallState;
}

export const initialState: EditAllowedIpState = {
   callState: LoadingState.Init,
};

const editAllowedIpReducer = createReducer(initialState);

export function reducer(state: EditAllowedIpState | undefined, action: Action) {
   return editAllowedIpReducer(state, action);
}
